import produce from 'immer';
import * as Actions from 'src/actions/types';
import * as AccountActions from 'src/actions/accountActions';
import * as Entities from 'src/config/Entities';

const initialState = {
  navigation: {
    tab: 'details'
  },
  member: null,
  fetching: false,
  mode: Entities.EntityMode.view
};

const mymemberReducer = (state = initialState, action) => {
  switch (action.type) {
    // NAVIGATION
    case Actions.ME_MEMBER_NAVIGATION_SET: {
      const { navigation } = action.payload;
      return produce(state, draft => {
        const newNav = {
          ...state.navigation,
          ...navigation
        };
        draft.navigation = newNav;
      });
    }

    // ENTITY
    case Actions.ME_MEMBER_MODE: {
      const { mode } = action.payload;
      return produce(state, draft => {
        draft.mode = mode;
      });
    }
    case Actions.ME_MEMBER_REQUEST: {
      return produce(state, draft => {
        draft.fetching = true;
      });
    }
    case Actions.ME_MEMBER_RECEIVE:
    case Actions.ME_MEMBER_UPDATE: {
      const { entity } = action.payload;
      return produce(state, draft => {
        draft.member = entity;
        draft.fetching = false;
      });
    }
    case Actions.ME_MEMBER_FINISHED: {
      return produce(state, draft => {
        draft.fetching = false;
      });
    }

    //------------------------------
    // From Account
    //------------------------------

    case AccountActions.LOGOUT:
    case AccountActions.LOGIN_REQUEST: {
      return produce(state, draft => {
        // Ensure we clear current session
        draft.member = null;
        draft.fetching = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default mymemberReducer;
